import { FilterOptionDate as FilterOptionDateMetric } from 'src/models/FilterMetric';
import { FilterOption as FilterOptionDrawer } from 'src/models/Filter';
import { FORMART_DATE_TAG_BUTTON } from 'src/components/DateRangePicker/DateRangePicker';

import { format } from 'date-fns';

// contast
import {
  rangeDate,
  dateLastFifteenOption,
  dateLastSevenOption,
  dateLastThirtyOption,
  dateToday,
  dateYesterday,
} from 'src/models/Filter/filterData';

const metricFilterDateToDrawerFilterDate = (
  filterMericOptionDate: FilterOptionDateMetric,
): FilterOptionDrawer => {
  if (filterMericOptionDate.id === 'range') {
    const startDate = new Date(filterMericOptionDate.startDate);
    const endDate = new Date(filterMericOptionDate.endDate);

    const descriptionFilterDrawerDate = `${format(
      startDate,
      FORMART_DATE_TAG_BUTTON,
    )} - ${format(endDate, FORMART_DATE_TAG_BUTTON)}`;

    return {
      ...rangeDate,
      id: 'range-date',
      categoryId: 'date',
      description: descriptionFilterDrawerDate,
      dates: {
        start: startDate,
        end: endDate,
      },
    };
  }

  if (filterMericOptionDate.id === 'fifteenDaysAgo') {
    return dateLastFifteenOption;
  }

  if (filterMericOptionDate.id === 'sevenDaysAgo') {
    return dateLastSevenOption;
  }
  if (filterMericOptionDate.id === 'thirtyDaysAgo') {
    return dateLastThirtyOption;
  }

  if (filterMericOptionDate.id === 'yerterday') {
    return dateYesterday;
  }

  return dateToday;
};

export default metricFilterDateToDrawerFilterDate;
